export const ONE_PAGE_EFFECTS = [
  {
    id: 'StoryParallax',
    name: 'StoryParallax',
    description: 'Premium single-spread parallax with layered depth',
    mobile: true
  },
  {
    id: 'VelvetCurl',
    name: 'Velvet Curl',
    description: 'Soft elegant paper-curl turn with refined shadow'
  },
  {
    id: 'CinematicGlide',
    name: 'Cinematic Glide',
    description: 'Smooth luxurious side-glide with subtle depth'
  },
  {
    id: 'LiftTurn',
    name: 'LiftTurn',
    description: 'Storybook page-lift motion with gentle upward peel'
  },
  {
    id: 'LuxeSlideFlip',
    name: 'Luxe SlideFlip',
    description: 'Minimal premium slide-flip for clean illustrated spreads'
  }
];

export const TWO_PAGE_EFFECTS = [
  {
    id: 'HardcoverClassic',
    name: 'Hardcover Classic',
    description: 'Rich hardbound book-style turn with stronger edge shadow'
  },
  {
    id: 'DeepShadowSpread',
    name: 'Deep Shadow Spread',
    description: 'Dramatic but elegant page turn with depth emphasis'
  },
  {
    id: 'MagazineFlow',
    name: 'Magazine Flow',
    description: 'Lighter editorial-style spread flip'
  },
  {
    id: 'GalleryTurn',
    name: 'Gallery Turn',
    description: 'Smooth clean transition for wide visual layouts'
  },
  {
    id: 'MinimalBookfold',
    name: 'Minimal Bookfold',
    description: 'Restrained two-page movement for quiet premium reading'
  }
];

export const NAVIGATION_STYLES = [
  {
    id: 'AirBar',
    name: 'AirBar',
    description: 'Floating minimal toolbar centered at bottom'
  },
  {
    id: 'CinemaDock',
    name: 'CinemaDock',
    description: 'Wide bottom cinematic control bar'
  },
  {
    id: 'SideRails',
    name: 'SideRails',
    description: 'Slim left/right vertical navigation rails'
  },
  {
    id: 'HaloTop',
    name: 'HaloTop',
    description: 'Compact premium top navigation bar'
  },
  {
    id: 'GhostEdges',
    name: 'GhostEdges',
    description: 'Almost invisible edge navigation'
  }
];
